<template>
	<div class="verify-box" :class="{'step_1':step==1,'step_2':step==2}">
		<span class="first-title f-s-13 w-550" :class="{'white':step==1,'pink':step==2}">移动积分→畅由积分</span>
		<span class="second-title f-s-13 w-550" :class="{'pink':step==1,'white':step==2}">畅由积分→{{xgTheme.transTitle}}</span>
		<div class="pink yd-price">
			<div class="f-s-18 w-600 t-c">{{step==1?order.cmssScore:order.cyScore}}</div>
			<div class="f-s-14 t-c">{{step==1?'移动积分':'畅由积分'}}</div>
		</div>
		<div class="to-div">
			<img src="../../assets/to_right.png"/>
		</div>
		<div class="blue cy-price">
			<div class="f-s-18 w-600 t-c">{{step==1?order.toCyScore:order.reserved2}}</div>
			<div class="f-s-14 t-c">{{step==1?'畅由积分':order.reserved1}}
			</div>
		</div>
		<div class="step-verify-div">
			<Verify :step="step" :smsStatus="smsStatus" :order="order" @nextStep="step=2" @payError="payError"></Verify>
		</div>
	</div>
</template>

<script>
	import Verify from './Verify.vue'
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from "vuex"
	export default {
		name: 'TwiceCode',
		computed: mapGetters(['xgTheme']),
		components: {
			[Verify.name]: Verify
		},
		data() {
			return {
				step: 1
			}
		},
		props: {
			smsStatus: {
				type: Number,
				default: 0
			},
			order: {
				type: Object,
				default: {}
			}
			
		},
		methods: {
			payError(){
				this.$emit('payErrorPoss')
				this.step = 1
			}
		},
	}
</script>

<style scoped>
	.verify-box {
		position: relative;
		width: 90vw;
		height: max-content;
		padding: 30px 20px;
		background-size: 100% 100%;
	}
	
	.step_1 {
		background-image: url(../../assets/step_1.png);
	}
	
	.step_2 {
		background-image: url(../../assets/step_2.png);
	}

	.first-title {
		position: absolute;
		top: 100px;
		left: 20px;
	}

	.second-title {
		position: absolute;
		top: 100px;
		right: 20px;
	}

	.yd-price {
		padding-top: 15px;
		text-align: center;
		position: absolute;
		width: 25vw;
		top: 150px;
		left: 15vw;
	}
	
	.to-div {
		padding-top: 20px;
		position: absolute;
		top: 150px;
		left: calc(50vw - 26px);
		width: 40px;
		height: 40px;
	}
	.to-div img{
		width: 100%;
		height: 100%;
	}

	.cy-price {
		padding-top: 15px;
		position: absolute;
		text-align: center;
		width: 25vw;
		top: 150px;
		right:10vw;
	}

	.step-verify-div {
		margin-top: 200px;
	}
</style>
